<template>
  <div class="section">
    <div class="container">
      <div class="row align-items-center">

        <div class="col-lg-6 mb-lg-30 ct-single-img-wrapper">
          <img :src="getImagePath('assets/images/pizzeria_wnetrze_01.jpg')" alt="img">
          <div class="ct-dots"></div>
        </div>
        <div class="col-lg-6">
          <div class="section-title-wrap mr-lg-30">
            <h5 class="custom-primary">Ponad 10 lat serwujemy pizzę</h5>
            <h2 class="title">Dostarczamy pizzę <br/>mieszkańcom Ząbek<br/>od 2009 roku</h2>
            <p>
              Naszą główną specjalnością jest oczywiście <strong>PIZZA</strong>, która już na
              stałe
              zagościła w sercach i żołądkach wielu smakoszy.
            </p>
            <p>
              Ciasto do jej wykonania wyrabiane jest przez znakomitych i zaufanych kucharzy
              według
              zastrzeżonej receptury. Chcielibyśmy, aby każdy mógł znaleźć coś specjalnie dla
              siebie,
              dlatego też nasza paleta prezentowanych wariantów pizzy jest bardzo urozmaicona
              i
              tak
              <strong>proponujemy Wam pizzę z mięsem, drobiem, owocami morza, pieczarkami,
                warzywami
                itd.</strong>
            </p>
            <p>
              W naszym menu znajdziecie też inne <strong>specjały kuchni włoskiej</strong>
              oraz
              sałatki.
            </p>
            <router-link to="/menu" class="btn-custom">
              {{ $t('Check our menu') }}
            </router-link>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import imageMixin from "@/mixins/imageMixin";

export default {
  name: 'about-us',
  mixins: [imageMixin],
}
</script>